import { render, staticRenderFns } from "./exchangeDetails.vue?vue&type=template&id=1379abd6&"
import script from "./exchangeDetails.vue?vue&type=script&lang=js&"
export * from "./exchangeDetails.vue?vue&type=script&lang=js&"
import style0 from "./exchangeDetails.vue?vue&type=style&index=0&lang=scss&scope=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports